import './App.css';
import profilePhoto from './profilephoto1.png';

function Contact() {
  return (
    <main className="contact-containment">
        <div className="contact-container">
          <div className="contact-card">
            <div className="centerphoto">
              <img src={profilePhoto} alt="Peter J. Pustorino" className="profile-photo-about" />
            </div>
            <div className="info">
              <h3>Peter J. Pustorino</h3>
              <p>Mediator</p>
              <p>Phone: <a href="tel:+16127190281">(612) 719-0281</a></p>
              <p>Email: <a href="mailto:pjpustorino@hotmail.com">pjpustorino@hotmail.com</a></p>
            </div>
          </div>

          <div className="contact-card">
            <div className="info">
              <h3>Kelly Grimm</h3>
              <p>Legal Assistant</p>
              <p>Phone: <a href="tel:+19526936225">(952) 693-6225</a></p>
              <p>Email: <a href="mailto:kellypgrimm@outlook.com">kellypgrimm@outlook.com</a></p>
            </div>
          </div>
        </div>
    </main>
  );
}

export default Contact;
